export default __webpack_public_path__ + "static/media/bonus.e7dbeba6.svg";